var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.86 15.497c-.293.293-.293.703 0 .996l6.855 6.797c.293.293.762.293.996 0l.41-.41c.294-.294.294-.704 0-.997l-5.976-5.918 6.035-5.859a.793.793 0 000-.996l-.469-.41c-.234-.293-.703-.293-.996 0l-6.855 6.797z"
  })));
}
export default SvgLeftArrowIcon;